import React, { useEffect, useState } from "react";
import { Dialog, Button } from "@/components/ui";
import { PaginatedPlayerList } from "@/components/Lists/PaginatedPlayerList";

interface OwnProps {
  open: boolean;
  values: number[];
  onUpdate: (values: number[]) => void;
  onClose: () => void;
}

type Props = OwnProps;

const PlayerSelectionModalFC: React.FC<Props> = ({ open, onClose, values, onUpdate }) => {
  const [selectedIds, setSelectedIds] = useState<number[]>(values);

  useEffect(() => {
    setSelectedIds(values);
  }, [values]);

  const handleChangeSelectedPlayer = (playerIds: number[], checked: boolean) => {
    if (checked) {
      setSelectedIds(prev => [...new Set([...prev, ...playerIds])]);
    } else {
      setSelectedIds(prev => prev.filter(id => !playerIds.includes(id)));
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={openState => {
        if (!openState) onClose();
      }}
      size="3xl"
      showCloseButton
    >
      <Dialog.Header className="border-b border-slate-100 pb-3">
        <Dialog.Title className="text-base font-bold text-slate-800">Select Specific Players</Dialog.Title>
        <Dialog.Description className="text-xs text-slate-400">
          Select individual players who should be directly eligible.
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.Content className="max-h-[500px] overflow-y-auto p-4">
        <div className="mt-2.5 h-[400px] overflow-hidden">
          <PaginatedPlayerList
            selectedPlayers={selectedIds}
            onChangeSelectedPlayer={handleChangeSelectedPlayer}
            scrollable={true}
          />
        </div>
      </Dialog.Content>
      <Dialog.Footer className="bg-slate-50 border-t border-slate-100 flex gap-2 justify-end">
        <Button variant="outline" type="button" onClick={onClose} className="rounded-lg text-xs py-1 px-4">
          Close
        </Button>
        <Button type="button" onClick={() => onUpdate(selectedIds)} className="rounded-lg text-xs py-1 px-4">
          Done
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};

export const PlayerSelectionModal = PlayerSelectionModalFC;
